import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const el = this.element;

    el.style.touchAction = 'none';

    this.sensitivity = 10;
    this.isPointerDown = false;
    this.lastX = 0;
    this.lastY = 0;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onLoad = this.onLoad.bind(this);

    el.addEventListener('load', this.onLoad, { capture: true });
    this.attachPointerListeners();
  }

  onLoad() {
    this.attachPointerListeners();
  }

  attachPointerListeners() {
    const el = this.element;

    const opts = { capture: true, passive: false };

    el.addEventListener('pointerdown', this.onPointerDown, opts);
    el.addEventListener('pointermove', this.onPointerMove, opts);
    el.addEventListener('pointerup', this.onPointerUp, opts);
    el.addEventListener('pointercancel', this.onPointerUp, opts);
    el.addEventListener('lostpointercapture', this.onPointerUp, opts);
  }

  onPointerDown(e) {
    e.stopImmediatePropagation();
    e.preventDefault();

    this.element.interactionPrompt = 'none'

    this.isPointerDown = true;
    this.lastX = e.clientX;
    this.lastY = e.clientY;

    this.element.setPointerCapture?.(e.pointerId);
  }

  onPointerMove(e) {
    if (!this.isPointerDown) return;
    e.stopImmediatePropagation();
    e.preventDefault();

    const dx = (e.clientX - this.lastX) * this.sensitivity;
    const dy = (e.clientY - this.lastY) * this.sensitivity;

    const orbit = this.element.getCameraOrbit();
    this.element.cameraOrbit = `${orbit.theta - dx / 100}rad ${orbit.phi - dy / 100}rad ${orbit.radius}m`;

    this.lastX = e.clientX;
    this.lastY = e.clientY;
  }

  onPointerUp(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    this.isPointerDown = false;
    this.element.releasePointerCapture?.(e.pointerId);
  }

  disconnect() {
    const el = this.element;
    el.removeEventListener?.('load', this.onLoad, { capture: true });

    const opts = { capture: true, passive: false };
    el.removeEventListener?.('pointerdown', this.onPointerDown, opts);
    el.removeEventListener?.('pointermove', this.onPointerMove, opts);
    el.removeEventListener?.('pointerup', this.onPointerUp, opts);
    el.removeEventListener?.('pointercancel', this.onPointerUp, opts);
    el.removeEventListener?.('lostpointercapture', this.onPointerUp, opts);
  }
}
